import React from "react";
import { ReactSVG } from "react-svg";

// region Imports - Assets
import { Alert } from "@assets/icons";
// endregion Imports - Assets
// region Imports - Libraries
import {
  DialogTitle,
  DialogActions,
  Button,
  Zoom,
  TransitionProps
} from "@libraries/mui";
// endregion Imports - Libraries
// region Imports - Languages
import { GlobalMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";
// endregion Imports - Languages
// region Imports - Styles
import * as Styled from "./styles";
// endregion Imports - Styles

// region Interfaces
interface IProps {
  open: boolean;
  onClose: () => void;
  title: string;
  iconColor: "yellow" | "red";
}
// endregion Interfaces

/** Transition helper component */
const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
  ) => <Zoom ref={ref} {...props} />
);

/** Component */
const AlertDialog: React.FC<IProps> = ({
  title,
  open,
  onClose,
  iconColor
}) => {
  const { t } = useTranslation();

  const getIconColor = () => (iconColor === "yellow" ? "#ffcc00" : "red");

  return (
    <Styled.Container
      open={open}
      onClose={onClose}
      aria-labelledby="alertDialog-title"
      aria-describedby="alertDialog-description"
      TransitionComponent={Transition}
    >
      <DialogTitle id="alertDialog-title">
        <Styled.IconContainer color={getIconColor()}>
          <ReactSVG src={Alert} className="alertDialog-title" />
        </Styled.IconContainer>
        {title}
      </DialogTitle>
      <DialogActions>
        <Styled.DialogActions>
          <Button onClick={onClose}>{t(GlobalMessages.buttonClose)}</Button>
        </Styled.DialogActions>
      </DialogActions>
    </Styled.Container>
  );
};

export default AlertDialog;
